import React from 'react';
import { Button } from '@pearsontechnology/aero-components';

import ErrorPage from 'components/ErrorPage';
import ErrorMessage from 'components/ErrorPage/messages';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import { HomePageLink } from './styles';

const UnAuthorizedPage = () => (
  <>
    <ErrorPage
      icon="warningOctagon"
      title={intl.formatMessage(ErrorMessage.unauthorizedTitle)}
      message={intl.formatMessage(ErrorMessage.unauthorizedDescription)}
    >
      <HomePageLink to="/">
        <Button primary>Back to home</Button>
      </HomePageLink>
    </ErrorPage>
  </>
);

export default UnAuthorizedPage;
